<template>
  <div id="print-referralfee">
    <div id="referralfee-page1" class="p-page d-flex">
      <div class="w-100">
        <div class="d-flex justify-content-center p-header">{{ data.companyName }}廠商領款(件)簽收單</div>
        <b-row>
          <b-col cols="12">
            <div style="display: inline-block; margin-right: 20px;">電話：{{ data.companyPhone }}</div>
            <div style="display: inline-block; margin-right: 20px;">傳真：{{ data.companyFax }}</div>
            <div style="display: inline-block;">Line：{{ data.companyLine }}</div>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12">
            <div style="display: inline-block; margin-right: 20px;">
              工單編號：<span class="text-primary">{{ data.caseNo }}</span>
            </div>
            <div style="display: inline-block; margin-right: 20px; min-width: 340px;">
              事業單位：<span class="text-primary">{{ data.name }}</span>
            </div>
            <div style="display: inline-block;">
              客戶名稱：<span class="text-primary">{{ data.contactName }}</span>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <div>救援設備 <span class="text-primary" style="margin-left: 16px;">{{ data.device }}</span></div>
          </b-col>
          <b-col cols="8">
            <div>型號 <span class="text-primary" style="margin-left: 16px;">{{ data.model }}</span></div>
          </b-col>
          <b-col cols="4">
            <div>廠牌 <span class="text-primary" style="margin-left: 16px;">{{ data.brand }}</span></div>
          </b-col>
          <b-col cols="8">
            <div>序號 <span class="text-primary" style="margin-left: 16px;">{{ data.serial }}</span></div>
          </b-col>
        </b-row>
        <div class="p-items-height">
          <b-row>
            <b-col cols="10"> 處理內容</b-col>
            <b-col class="text-right"> 金額</b-col>
          </b-row>
          <b-row class="p-content" v-for="item in data.items" :key="item.content">
            <b-col cols="10" class="text-primary">{{ item.content }}</b-col>
            <b-col class="text-right text-primary">{{ $function.priceformatWithMark(item.print * item.quantity)
              }}</b-col>
          </b-row>
        </div>
        <b-row>
          <b-col></b-col>
          <b-col>
            <hr style="border-top: 2px solid #000; margin-top: 0.5rem; margin-bottom: 0.5rem" />
            <b-row>
              <b-col class="text-right" cols="8">救援費用：</b-col>
              <b-col class="text-right text-primary">{{ $function.priceformatWithMark(data.subTotal) }}</b-col>
            </b-row>
            <b-row class="text-danger">
              <b-col class="text-right" cols="8">領取佣金(救援費用*{{ fee }}%)：</b-col>
              <b-col class="text-right">{{ $function.priceformatWithMark(Math.round(data.subTotal * (fee / 100)))
                }}</b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr />
        <b-row class="text-danger">
          <b-col>經銷商編號：{{ data.referrerNo }}</b-col>
          <b-col>公司名稱：{{ data.referrerName }}</b-col>
          <b-col>請款人：{{ data.referrerContactName }}</b-col>
        </b-row>
        <div class="p-items-height">
          <b-row>
            <b-col> 交付內容</b-col>
            <b-col class="text-right"> 數量</b-col>
          </b-row>
          <b-row class="p-content text-danger">
            <b-col>佣金</b-col>
            <b-col class="text-right">1</b-col>
          </b-row>
        </div>
      </div>
      <div class="p-sub-desc">第一聯<br />：經銷商</div>
    </div>

    <div id="referralfee-page2" class="p-page d-flex">
      <div class="w-100">
        <div class="d-flex justify-content-center p-header">{{ data.companyName }}廠商領款(件)簽收單</div>
        <b-row>
          <b-col cols="12">
            <div style="display: inline-block; margin-right: 20px;">電話：{{ data.companyPhone }}</div>
            <div style="display: inline-block; margin-right: 20px;">傳真：{{ data.companyFax }}</div>
            <div style="display: inline-block;">Line：{{ data.companyLine }}</div>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12">
            <div style="display: inline-block; margin-right: 20px;">
              工單編號：<span class="text-primary">{{ data.caseNo }}</span>
            </div>
            <div style="display: inline-block; margin-right: 20px; min-width: 340px;">
              事業單位：<span class="text-primary">{{ data.name }}</span>
            </div>
            <div style="display: inline-block;">
              客戶名稱：<span class="text-primary">{{ data.contactName }}</span>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <div>救援設備 <span class="text-primary" style="margin-left: 16px;">{{ data.device }}</span></div>
          </b-col>
          <b-col cols="8">
            <div>型號 <span class="text-primary" style="margin-left: 16px;">{{ data.model }}</span></div>
          </b-col>
          <b-col cols="4">
            <div>廠牌 <span class="text-primary" style="margin-left: 16px;">{{ data.brand }}</span></div>
          </b-col>
          <b-col cols="8">
            <div>序號 <span class="text-primary" style="margin-left: 16px;">{{ data.serial }}</span></div>
          </b-col>
        </b-row>
        <div class="p-items-height">
          <b-row>
            <b-col cols="10"> 處理內容</b-col>
            <b-col class="text-right"> 金額</b-col>
          </b-row>
          <b-row class="p-content" v-for="item in data.items" :key="item.content">
            <b-col cols="10" class="text-primary item-content">{{ item.content }}</b-col>
            <b-col class="text-right text-primary">{{ $function.priceformatWithMark(item.print * item.quantity)
              }}</b-col>
          </b-row>
        </div>
        <b-row>
          <b-col></b-col>
          <b-col>
            <hr style="border-top: 2px solid #000; margin-top: 0.5rem; margin-bottom: 0.5rem" />
            <b-row>
              <b-col class="text-right" cols="8">救援費用：</b-col>
              <b-col class="text-right text-primary">{{ $function.priceformatWithMark(data.subTotal) }}</b-col>
            </b-row>
            <b-row class="text-danger">
              <b-col class="text-right" cols="8">領取佣金(救援費用*{{ fee }}%)：</b-col>
              <b-col class="text-right">{{ $function.priceformatWithMark(Math.round(data.subTotal * (fee / 100)))
                }}</b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr />
        <b-row class="text-danger">
          <b-col>經銷商編號：{{ data.referrerNo }}</b-col>
          <b-col>公司名稱：{{ data.referrerName }}</b-col>
          <b-col>請款人：{{ data.referrerContactName }}</b-col>
        </b-row>
        <div class="p-items-height">
          <b-row>
            <b-col> 交付內容</b-col>
            <b-col class="text-right"> 數量</b-col>
          </b-row>
          <b-row class="p-content text-danger">
            <b-col>佣金</b-col>
            <b-col class="text-right">1</b-col>
          </b-row>
        </div>

        <div class="p-margin-top">
          <b-row>
            <b-col cols="8"> 收款(件)人簽收：</b-col>
            <b-col>{{ data.date }}</b-col>
          </b-row>
        </div>
      </div>
      <div class="p-sub-desc">第二聯<br />：會計</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ReferralfeePrintPage",
  props: ["data", "fee"],
};
</script>
<style lang="scss" scoped>
@media print {
  #print-referralfee {
    display: block !important;
    height: 100%;
    background-color: #fff;
    padding-top: 18px;
  }

  .p-page {
    height: 50%;

  }

  .p-table-color {
    td {
      background-color: #d9d9d9 !important;
    }
  }
}

#print-referralfee {
  display: none;
  font-weight: 900;
  font-size: 20px;
  font-family: "微軟正黑體";
}

.p-sub-desc {
  width: 24px;
  padding-left: 5px;
  padding-top: 75px;
}

.p-table-color {
  td {
    background-color: #d9d9d9 !important;
  }
}

.p-table {
  width: 100%;

  .w-33 {
    width: 33%;
  }

  .w-10 {
    width: 10%;
  }

  .w-60 {
    width: 60%;
  }

  .w-15 {
    width: 15%;
  }

  td {
    border: 1px solid black;
  }

  .p-content {
    border-top-width: 0;
    border-bottom-width: 0;

  }

  .p-board-top {
    border-bottom-width: 0;
  }

  .p-board-bottom {
    border-top-width: 0;
  }
}

.p-page {
  padding-left: 50px;
  padding-right: 26px;
}

.p-header {
  padding-bottom: 8px;
  font-size: 40px;
}

.p-text-big {
  font-size: 28px;
}

.p-margin {
  margin-bottom: 16px;
}

.p-margin-top {
  margin-top: 24px;
}

.p-margin-top-max {
  margin-top: 300px;
}

.p-margin-x {
  margin-top: 38px;
  margin-bottom: 38px;
}

.item-content {
  word-break: break-all;
}
</style>
